import { useCanViewCoverPages } from "../cover-pages/access"
import Image from "@pathwright/ui/src/components/image/Image"
import Link from "@pathwright/ui/src/components/link/Link"
import styled from "styled-components"
import { getStoreResourceUrl } from "../utils/urls"

const StyledThumbnail = styled(Link)`
  z-index: 1;
  position: absolute !important;
  width: 30px;
  top: -7px;
  left: -7px;
  pointer-events: auto;
  img {
    outline: none;
    border-radius: 5px;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.3);
    width: 30px;
    height: 22.5px;
  }
`

const ResourceThumbnail = ({ resource }) => {
  const coverPageEnabled = useCanViewCoverPages()
  return (
    <StyledThumbnail to={getStoreResourceUrl(resource.slug, coverPageEnabled)}>
      <Image src={resource.image} alt="thumbnail" />
    </StyledThumbnail>
  )
}

ResourceThumbnail.displayName = "ResourceThumbnail"

export default ResourceThumbnail
